import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/http/api.service';
import { API_URL } from 'src/app/shared/service/api.constant';
import { Person } from '@shared/models/user.model';
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  userProfileImageStorage = localStorage.getItem('photoUrl');
  userProfileNameStorage = localStorage.getItem('name');
  userProfileFullNameStorage = localStorage.getItem('full_name');
  userProfileJobPositionStorage =
    localStorage.getItem('job_position');

  constructor(private http: ApiService) {}

  loadInputData() {
    return this.http.get(
      API_URL.people + localStorage.getItem('person_id') + '/',
    );
  }

  // Person
  getPeopleList(params?: any): Observable<unknown> {
    return this.http.get(API_URL.people, params);
  }

  createPerson(data: any) {
    return this.http.post(API_URL.people, data);
  }

  updatePerson(id: any, data: any) {
    return this.http.patch(API_URL.people + id + '/', data);
  }

  getPersonDetail(id: number): Observable<Person> {
    return this.http.get<Person>(API_URL.people + id + '/');
  }

  disablePerson(id: number) {
    return this.http.patch(
      API_URL.people + id + '/disable-user/',
      {},
    );
  }

  enablePerson(id: number) {
    return this.http.patch(API_URL.people + id + '/enable-user/', {});
  }

  deleteUser(id: number, data?: any) {
    return this.http.patch(
      `${API_URL.people}${id}/inactive-user/`,
      data,
    );
  }

  // Document
  getProfileDocument(params: any) {
    return this.http.get(API_URL.profiles_files, params);
  }

  uploadProfileDocument(data: any) {
    return this.http.post(API_URL.profiles_files, data);
  }

  deleteProfileDocument(id: any) {
    return this.http.delete(API_URL.profiles_files + id + '/');
  }

  setPassword(data: any) {
    return this.http.put(API_URL.change_password, data);
  }

  // Setting notifications
  getLinkLineCODIUM() {
    return this.http.get(API_URL.link_line_codium);
  }

  getLinkLineUser() {
    return this.http.get(API_URL.link_line_user);
  }

  settingEmail(id: any, data: any) {
    return this.http.patch(API_URL.setting_email + id + '/', data);
  }

  // Delegate
  getDelegate() {
    return this.http.get(API_URL.delegate_permission);
  }

  createDelegate(data: any) {
    return this.http.post(API_URL.delegate_permission, data);
  }

  updateDelegate(id: any, data: any) {
    return this.http.patch(
      API_URL.delegate_permission + id + '/',
      data,
    );
  }

  deleteDelegate(id: any) {
    return this.http.delete(API_URL.delegate_permission + id + '/');
  }

  // OTP
  OpenOtp(data: any) {
    return this.http.post(API_URL.open_otp, data);
  }

  CloseOtp(data: any) {
    return this.http.post(API_URL.close_otp, data);
  }

  verifyOtp(data: any) {
    return this.http.post(API_URL.verify_otp, data);
  }

  // Update LocalStorage
  setUserProfileImage(profileImageUrl: any) {
    localStorage.setItem('photoUrl', profileImageUrl);
    this.refreshUserProfileImage();
  }

  setUserName(name: any) {
    localStorage.setItem('name', name);
    this.userProfileNameStorage = localStorage.getItem('name');
  }

  setUserFullName(fullName: any) {
    localStorage.setItem('full_name', fullName);
    this.userProfileFullNameStorage =
      localStorage.getItem('full_name');
  }

  setUserJobPosition(jobPosition: any) {
    localStorage.setItem('job_position', jobPosition);
    this.userProfileJobPositionStorage =
      localStorage.getItem('job_position');
  }

  setUserHasSignature(signature: any) {
    localStorage.setItem(
      'no_signature',
      signature ? 'false' : 'true',
    );
  }

  refreshUserProfileName() {
    this.userProfileNameStorage = localStorage.getItem('name');
    this.userProfileFullNameStorage =
      localStorage.getItem('full_name');
    this.userProfileJobPositionStorage =
      localStorage.getItem('job_position');
  }

  refreshUserProfileImage() {
    this.userProfileImageStorage = localStorage.getItem('photoUrl');
  }

  setLocalStorageUpdateProfile(data: any) {
    this.setUserName(data.first_name);
    this.setUserFullName(data.full_name);
    this.setUserProfileImage(data.photo);
    this.setUserHasSignature(data.signature);
  }

  updatePreferredLanguage(id: any, language: any) {
    return this.http.patch(
      API_URL.people + id + '/update-preferred-language/',
      { preferred_language: language },
    );
  }

  resetPassword(userId: number, data?: any) {
    return this.http.patch<{ password: string }>(
      `/api/people/${userId}/reset-password/`,
      data,
    );
  }

  resetMfa(userId: number) {
    return this.http.patch(`/api/people/${userId}/reset-mfa/`, {});
  }

  unlockUser(id: number) {
    return this.http.patch(
      `${API_URL.people}${id}/unlock-user/`,
      null,
    );
  }
}
